<template>
	<div class="__report-lesson px-12 md-down:px-4 pb-30 relative">
		<div
			class="__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl"
			>
				<svg
					class="mr-3 h-6 w-6"
					viewBox="0 0 28 28"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M19.25 3.5C19.25 2.5335 20.0335 1.75 21 1.75H24.5C25.4665 1.75 26.25 2.5335 26.25 3.5V24.5H27.125C27.6082 24.5 28 24.8918 28 25.375C28 25.8582 27.6082 26.25 27.125 26.25H0.875C0.391751 26.25 0 25.8582 0 25.375C0 24.8918 0.391751 24.5 0.875 24.5H1.75V19.25C1.75 18.2835 2.5335 17.5 3.5 17.5H7C7.9665 17.5 8.75 18.2835 8.75 19.25V24.5H10.5V12.25C10.5 11.2835 11.2835 10.5 12.25 10.5H15.75C16.7165 10.5 17.5 11.2835 17.5 12.25V24.5H19.25V3.5Z"
						fill="#94A3B8"
					/>
				</svg>

				Biểu đồ Thống kê
			</div>
			<div class="input-group">
				<VueDatepicker
					class="input-date w-full"
					placeholder="Chọn tháng"
					uid="filter-by-date"
					v-model="date"
					auto-apply
					month-picker
					format="MM/yyyy"
					:min-date="new Date(2026, 0, 1)"
					:max-date="new Date()"
				>
					<template #input-icon>
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
								fill="#94A3B8"
							/>
						</svg>
					</template>
				</VueDatepicker>
			</div>
		</div>
		<div class="mb-10 sticky top-0 bg-body z-1">
			<div class="border-b py-6 border-neutral-200">
				<nav class="flex space-x-8 tabs" aria-label="Tabs">
					<div v-for="i in tabs" :key="i.id">
						<a
							@click="tab = i.id"
							:href="i.id"
							class="order-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap pb-6 pt-4 px-1 font-semibold cursor-pointer"
							:class="
								i.id === tab
									? 'border-b-2 text-yellow-700 border-yellow-500'
									: 'text-neutral-500'
							"
						>
							{{ i.name }}
						</a>
					</div>
				</nav>
			</div>
		</div>
		<div id="student">
			<div class="w-full mb-10">
				<div class="relative">
					<div
						class="absolute inset-0 flex items-center"
						aria-hidden="true"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="bg-body px-2 text-neutral-600 font-semibold whitespace-nowrap flex flex-nowrap items-center text-2xl justify-center gap-6"
						>
							<div>Về học sinh</div>
						</div>
					</div>
				</div>
			</div>
			<div
				style="border-radius: 16px"
				class="pt-4 opacity-100 gap-[12px] p-[16px] bg-white shadow-[0px_3px_8px_-1px_#3232470D] shadow-[0px_0px_1px_0px_#0C1A4B3D]"
			>
				<div class="font-semibold text-sm text-neutral-900 pl-4">
					Số học sinh theo trạng thái
				</div>
				<BaseStackedBarChart
					:series="studentStats?.studentByStatus?.data"
					:categories="studentStats?.studentByStatus?.xAxis"
					:colors="['#2AA797', '#E37056', '#F4C870']"
				/>
			</div>
			<div
				style="border-radius: 16px"
				class="mt-8 pt-4 opacity-100 gap-[12px] p-[16px] bg-white shadow-[0px_3px_8px_-1px_#3232470D] shadow-[0px_0px_1px_0px_#0C1A4B3D]"
			>
				<div class="font-semibold text-sm text-neutral-900 pl-4">
					Số học sinh theo mô hình
				</div>
				<BaseStackedBarChart
					:series="studentStats?.studentByModel?.data"
					:categories="studentStats?.studentByModel?.xAxis"
					:colors="['#84CC16', '#6390C3', '#4F46E5']"
				/>
			</div>
		</div>
		<div id="staff">
			<div class="w-full mb-10 mt-10">
				<div class="relative">
					<div
						class="absolute inset-0 flex items-center"
						aria-hidden="true"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="bg-body px-2 text-neutral-600 font-semibold whitespace-nowrap flex flex-nowrap items-center text-2xl justify-center gap-6"
						>
							<div>Về nhân sự</div>
						</div>
					</div>
				</div>
			</div>
			<div
				style="border-radius: 16px"
				class="mt-8 pt-4 opacity-100 gap-[12px] p-[16px] bg-white shadow-[0px_3px_8px_-1px_#3232470D] shadow-[0px_0px_1px_0px_#0C1A4B3D]"
			>
				<div class="font-semibold text-sm text-neutral-900 pl-4">
					Số nhân sự theo trạng thái
				</div>
				<BaseStackedBarChart
					:series="staffStats?.staffByStatus?.data"
					:categories="staffStats?.staffByStatus?.xAxis"
					:colors="['#2AA797', '#F4C870', '#E37056']"
				/>
			</div>
			<div
				style="border-radius: 16px"
				class="mt-8 pt-4 opacity-100 gap-[12px] p-[16px] bg-white shadow-[0px_3px_8px_-1px_#3232470D] shadow-[0px_0px_1px_0px_#0C1A4B3D]"
			>
				<div class="font-semibold text-sm text-neutral-900 pl-4">
					Số nhân sự theo vai trò
				</div>
				<BaseStackedBarChart
					:series="staffStats?.staffByRole?.data"
					:categories="staffStats?.staffByRole?.xAxis"
					:colors="[
						'#A78BFA',
						'#86CEBA',
						'#86A8D0',
						'#F6D692',
						'#F1A267',
					]"
				/>
			</div>
			<div
				style="border-radius: 16px"
				class="mt-8 pt-4 opacity-100 gap-[12px] p-[16px] bg-white shadow-[0px_3px_8px_-1px_#3232470D] shadow-[0px_0px_1px_0px_#0C1A4B3D]"
			>
				<div class="font-semibold text-sm text-neutral-900 pl-4">
					Số nhân sự theo mô hình
				</div>
				<BaseStackedBarChart
					:series="staffStats?.staffByModel?.data"
					:categories="staffStats?.staffByModel?.xAxis"
					:colors="['#84CC16', '#4F46E5', '#6390C3']"
				/>
			</div>
		</div>
		<div id="result">
			<div class="w-full mb-10 mt-10">
				<div class="relative">
					<div
						class="absolute inset-0 flex items-center"
						aria-hidden="true"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="bg-body px-2 text-neutral-600 font-semibold whitespace-nowrap flex flex-nowrap items-center text-2xl justify-center gap-6"
						>
							<div>Về kết quả học tập</div>
						</div>
					</div>
				</div>
			</div>
			<div
				style="border-radius: 16px"
				class="mt-8 pt-4 opacity-100 gap-[12px] p-[16px] bg-white shadow-[0px_3px_8px_-1px_#3232470D] shadow-[0px_0px_1px_0px_#0C1A4B3D]"
			>
				<div class="font-semibold text-sm text-neutral-900 pl-4">
					Kết quả học tập của học sinh
				</div>
				<BaseStackedBarChart
					:yaxisMax="100"
					:series="assessmentStats?.assessmentByResult?.data"
					:categories="assessmentStats?.assessmentByResult?.xAxis"
					:colors="['#F87171', '#FBBF24', '#84CC16', '#2AA797']"
				/>
			</div>
		</div>
		<div id="diligence">
			<div class="w-full mb-10 mt-10">
				<div class="relative">
					<div
						class="absolute inset-0 flex items-center"
						aria-hidden="true"
					>
						<div class="w-full border-t border-neutral-300" />
					</div>
					<div class="relative flex justify-center">
						<div
							class="bg-body px-2 text-neutral-600 font-semibold whitespace-nowrap flex flex-nowrap items-center text-2xl justify-center gap-6"
						>
							<div>Chuyên cần</div>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="enablePersonalSchedule"
				class="mt-8 pt-4 opacity-100 gap-[12px] p-[16px] bg-white shadow-[0px_3px_8px_-1px_#3232470D] shadow-[0px_0px_1px_0px_#0C1A4B3D] rounded-2xl"
			>
				<div class="font-semibold text-sm text-neutral-900 pl-4">
					Chuyên cần can thiệp cá nhân
				</div>
				<BaseStackedBarChart
					:series="sessionsStats?.sessionsByIndividual?.data"
					:categories="sessionsStats?.sessionsByIndividual?.xAxis"
					:colors="['#4F46E5', '#818CF8']"
				/>
			</div>
			<div class="p-4 mt-8 bg-white shadow-sm rounded-2xl" v-else>
				<div class="flex flex-col items-center justify-center">
					<img
						style="width: 140px; height: 140px"
						src="@/assets/images/illustrations/not_found.png"
						alt=""
					/>
					<div class="font-semibold text-neutral-600 mt-4">
						Chưa có dữ liệu chuyên cần
					</div>
					<div class="text-gray-400 mt-4 text-center">
						Trung tâm đang tắt lịch học, nên hệ thống chưa thể thống
						kê chuyên cần (Giờ học thực tế / Giờ học dự kiến).<br />Vui
						lòng bật lịch học để theo dõi biểu đồ chuyên cần
					</div>
					<button
						class="luca-button w-max whitespace-nowrap mt-4"
						@click="$router.push(`/setup-center/schedule?step=2`)"
					>
						Bật lịch học
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { $api } from '@/services';
import BaseStackedBarChart from '@/views/dashboard/chart/BaseStackedBarChart.vue';

export default {
	name: 'DashboardStatsChart',
	components: {
		BaseStackedBarChart,
	},

	data() {
		return {
			tabs: [
				{ name: 'Học sinh', id: '#student' },
				{ name: 'Nhân sự', id: '#staff' },
				{ name: 'Kết quả học tập', id: '#result' },
				{ name: 'Chuyên cần', id: '#diligence' },
			],
			tab: '#student',
			date: {
				month: new Date().getMonth(),
				year: new Date().getFullYear(),
			},
			studentStats: {
				studentByStatus: {
					data: [],
					xAxis: [],
				},
				studentByModel: {
					data: [],
					xAxis: [],
				},
			},
			staffStats: {
				staffByStatus: {
					data: [],
					xAxis: [],
				},
				staffByRole: {
					data: [],
					xAxis: [],
				},
				staffByModel: {
					data: [],
					xAxis: [],
				},
			},
			assessmentStats: {
				assessmentByResult: {
					data: [],
					xAxis: [],
				},
			},
			sessionsStats: {
				sessionsByIndividual: {
					data: [],
					xAxis: [],
				},
			},
		};
	},

	computed: {
		datePayload() {
			return dayjs(new Date(this.date.year, this.date.month, 10)).format(
				'YYYY-MM-DD'
			);
		},
		enablePersonalSchedule() {
			return this.$store.state.profile.enable_personal_schedule;
		},
	},

	watch: {
		date: {
			deep: true,
			handler(value) {
				if (value) {
					this.fetchDashboardChart();
				}
			},
		},
	},

	created() {
		this.fetchDashboardChart();
	},

	methods: {
		async fetchDashboardChart() {
			try {
				const { data } = await $api.leader.fetchDashboardChart({
					date: this.datePayload,
				});

				const {
					student_stats,
					staff_stats,
					assessment_stats,
					sessions_stats,
				} = data;
				this.setStudentStats(student_stats);
				this.setStaffStats(staff_stats);
				this.setAssessmentStats(assessment_stats);
				this.setSessionsStats(sessions_stats);
			} catch (err) {
				await this.$store.dispatch('setAlertMessage', {
					message: 'Có lỗi xảy ra, vui lòng thử lại.',
					type: 'danger',
				});
			}
		},
		setStudentStats(student_stats) {
			this.studentStats = {
				studentByStatus: {
					data: student_stats.student_by_status.data,
					xAxis: student_stats.student_by_status.x_axis,
				},
			};
			this.studentStats.studentByModel = {
				data: student_stats.student_by_model.data,
				xAxis: student_stats.student_by_model.x_axis,
			};
		},
		setStaffStats(staff_stats) {
			this.staffStats = {
				staffByStatus: {
					data: staff_stats.staff_by_status.data,
					xAxis: staff_stats.staff_by_status.x_axis,
				},
			};
			this.staffStats.staffByRole = {
				data: staff_stats.staff_by_role.data,
				xAxis: staff_stats.staff_by_role.x_axis,
			};
			this.staffStats.staffByModel = {
				data: staff_stats.staff_by_model.data,
				xAxis: staff_stats.staff_by_model.x_axis,
			};
		},
		setAssessmentStats(assessment_stats) {
			this.assessmentStats = {
				assessmentByResult: {
					data: assessment_stats.assessment_by_result.data,
					xAxis: assessment_stats.assessment_by_result.x_axis,
				},
			};
		},
		setSessionsStats(sessions_stats) {
			this.sessionsStats = {
				sessionsByIndividual: {
					data: sessions_stats.sessions_by_individual.data,
					xAxis: sessions_stats.sessions_by_individual.x_axis,
				},
			};
		},
	},
};
</script>
<style scoped>
.z-1 {
	z-index: 1;
}
</style>